// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnCon{
    margin-top: 18px;
    margin-bottom: -12px;
    
    }
    .btns{
        width: 14%;
        height: 6vh;
        font-size: 14px;
    }
    .body-login{
        width: 100%;    
        height: 100%;
    }
 `, "",{"version":3,"sources":["webpack://./src/app/users-management/list-users/login-info/login-info.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,oBAAoB;;IAEpB;IACA;QACI,UAAU;QACV,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB","sourcesContent":[".btnCon{\r\n    margin-top: 18px;\r\n    margin-bottom: -12px;\r\n    \r\n    }\r\n    .btns{\r\n        width: 14%;\r\n        height: 6vh;\r\n        font-size: 14px;\r\n    }\r\n    .body-login{\r\n        width: 100%;    \r\n        height: 100%;\r\n    }\r\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
